// extracted by mini-css-extract-plugin
export var collapsedSummary = "_pk-0";